import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './@core/guards';



const routes: Routes = [
  {
    path: '', loadChildren: () => import('./landing-page/landing-page.module').then(m => m.LandingPageModule)
  },
  {
      path: 'auth', loadChildren: () => import('./auth/auth.module').then(m => m.AuthModule)
  },
  {
    path: 'home', loadChildren: () => import('./home/home.module').then(m => m.HomeModule), canActivate: [AuthGuard]
  },
  {
    path: 'past-donation', loadChildren: () => import('./past-donation/past-donation.module').then(m => m.PastDonationModule), canActivate: [AuthGuard]
  },
  {
    path: 'transactions', loadChildren: () => import('./transactions/transactions.module').then(m => m.TransactionsModule), canActivate: [AuthGuard]
  },
  {
    path: 'settings', loadChildren: () => import('./settings/settings.module').then(m => m.SettingsModule), canActivate: [AuthGuard]
  }
  
  // {
  //     path: '', redirectTo: 'home', pathMatch: 'full'
  // },
  // {
  //     path: 'home', loadChildren: './home/home.module#HomeModule'
  // }
  // ,
  // {
  //     path: 'reports', loadChildren: './reports/reports.module#ReportsModule'
  // },
  // {
  //     path: 'news', loadChildren: './news/news.module#NewsModule', canActivate: [AuthGuard]
  // },
  // {
  //     path: 'profile/:id', loadChildren: './profile/profile.module#ProfileModule', canActivate: [AuthGuard]
  // },
  // {
  //     path: 'tourist-attractions', loadChildren: './tourist-attractions/tourist-attractions.module#TouristAttractionsModule', canActivate: [AuthGuard]
  // },
  // {
  //     path: 'topics', loadChildren: './topics/topics.module#TopicsModule', canActivate: [AuthGuard]
  // },
  // {
  //     path: 'flyers', loadChildren: './flyers/flyers.module#FlyersModule', canActivate: [AuthGuard]
  // },
  // {
  //     path: '**', redirectTo: 'home', pathMatch: 'full'
  // },

];


@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
